module.exports = __webpack_public_path__ + "fonts/lato-blackitalic-webfont.35c183a2.woff";